import { useTranslation } from 'react-i18next'

type CoreErrorDiagnosticProps = {
  error: Error
  color?: string
}

const errorCodeFor = (error: Error) => {
  if (!('code' in error)) return null
  const code = error.code
  return typeof code === 'string' && code.trim() ? code : null
}

export function CoreErrorDiagnostic({ error, color }: CoreErrorDiagnosticProps) {
  const { t } = useTranslation()
  const errorCode = errorCodeFor(error)

  return (
    <details className="mt-3 border-t border-current/20 pt-2 text-xs" style={{ color }}>
      <summary className="min-h-11 cursor-pointer select-none py-2 font-medium">
        {t('core.errors.technicalDetails', { defaultValue: 'Technical details' })}
      </summary>
      <div className="space-y-1 pb-1 font-mono leading-5">
        {errorCode ? <p className="break-all font-semibold">{errorCode}</p> : null}
        <p className="break-words">{error.message}</p>
      </div>
    </details>
  )
}
